import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormCloth from './form/FormCloth'

function NewCloth({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerCloth(cloth) {
        let msgType = 'success'

        const data = await api.post('/cloth/new', cloth, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormCloth title="Cadastrar Tecido" handleSubmit={registerCloth} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewCloth
